import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import { useUtility } from '../../context/UtilityContext';
import { formatMobNumber, capitalizeFLetter } from '../../utils/commonUtils';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllMetadata } from '../../reducers/MetaData/metadata-actions';

const MetadataDropdown = ({ className = '', showLabel = true }) => {
  const dispatch = useDispatch();
  const { metadataList, loading, error } = useSelector((state) => state.metadata);
  const { selectedMetadataId, setSelectedMetadataId } = useUtility();

  useEffect(() => {
    if (!metadataList.length) {
      dispatch(fetchAllMetadata({ page: 0, limit: 50 }));
    }
  }, [dispatch, metadataList.length]);

  if (loading) {
    return (
      <div className={`flex align-items-center gap-2 ${className}`}>
        <Skeleton width="12rem" height="2.5rem" />
      </div>
    );
  }

  if (error) {
    return (
      <div className={`flex align-items-center gap-2 ${className}`}>
        <span className="text-red-500">{error}</span>
      </div>
    );
  }

  if (!metadataList.length) {
    return (
      <div className={`flex align-items-center gap-2 ${className}`}>
        <span>No WhatsApp accounts found</span>
      </div>
    );
  }

  const dropdownOptions = metadataList.map((meta) => {
    return {
      value: String(meta.id),
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span>{capitalizeFLetter(meta?.name) || 'Unknown'}</span>
          <span>{formatMobNumber(meta?.phoneNumber)}</span>
        </div>
      ),
    };
  });

  return (
    <div className={`flex align-items-center gap-2 ${className}`}>
      {showLabel && <label className="font-semibold text-sm text-color-secondary">Accounts:</label>}

      <Dropdown
        value={selectedMetadataId}
        options={dropdownOptions}
        onChange={(e) => setSelectedMetadataId(String(e.value))}
        placeholder="Select WhatsApp Account"
        className="w-full md:w-20rem"
      />
    </div>
  );
};

export default MetadataDropdown;
